import {compose} from 'redux';
import withUsers from '../../../_common/components/Users/components/withUsers';
import UsersActionsFilters from './UsersActionsFilters';

export default compose(
  withUsers
)(UsersActionsFilters);
